
import * as Constants from './Constants';

const initialState = {
  isCartVisible: true,
  tosSignature: '',
  tosSendLinkTriggered: false,
  enableTOSBtn: false,
  submitSignatureResponse: '',
};

function termsAndConditions(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, data: action.response && action.response.data };
    case Constants.UPDATE_SHOW_CART: {
      return { ...state, isCartVisible: action.data };
    }
    case 'UPDATE_TOS_SIGNATURE': {
      return { ...state, tosSignature: action.response };
    }
    case 'SEND_LINK_ACTION_TRIGGERED': {
      return { ...state, tosSendLinkTriggered: action.data };
    }
    case 'ENABLE_TERMS_AND_CONDITION_SUBMIT': {
      return { ...state, enableTOSBtn: action.response };
    }
    case 'POST_SUBMIT_SIGNATURE_RESPONSE': {
      return { ...state, submitSignatureResponse: action.response };
    }
    default:
      return state;
  }
}


export default termsAndConditions;
